<ng-container *ngTemplateOutlet="customTemplate ? customTemplate : defaultTemplate; 
 context:{$implicit: {openDialog: openDialog, updateValues: updateValues, dialog: dialog}}">
</ng-container>

<!-- default template is provided here -->
<ng-template #defaultTemplate>
  @if (showAsIcon) {
    <mat-icon  [matTooltip]="'share.shareMap' | translate"
      (click)="openDialog()" mat-list-icon aria-hidden="false">
      share
    </mat-icon>
  }
</ng-template>

